export const DEFAULT_DRAG_START_DISTANCE = 5;
export const BODY_IS_DRAGGING_CLASS = 'fly-drag-drop-is-dragging';